import {LISTATENTIONS} from '../types';

export const atencionListaAction = ( data ) => async (dispatch) =>{

    dispatch({
        type: LISTATENTIONS,
        payload: data
    });

}